import styles from './button.module.scss';
import { ReactNode } from 'react';
import MaterialButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';

/* eslint-disable-next-line */
export interface ButtonProps {
  children: any,
  // classes?: object,
  color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
  component?: any,
  disabled?: boolean,
  // disableElevation?: boolean,
  // disableFocusRipple?: boolean,
  // disableRipple?: boolean,
  endIcon?: ReactNode,
  fullWidth?: boolean,
  href?: string,
  download?: string,
  size?: 'small' | 'medium' | 'large',
  startIcon?: ReactNode,
  sx?: any,
  variant?: 'contained' | 'outlined' | 'text',
  onClick?: (...args: any[]) => void,
  className?: string,
  target?: string,
  ['data-testid']?: string
}

const Input = styled('input')({
  display: 'none',
});

export function Button(props: ButtonProps) {
  const localSx = {
    textTransform: 'none',
  };

  return (
    <MaterialButton
      disabled={props.disabled}
      onClick={props.onClick}
      variant={props.variant}
      color={props.color}
      startIcon={props.startIcon}
      endIcon={props.endIcon}
      component={props.component}
      className={`${props.className}`}
      size={props.size}
      href={props.href}
      download={props.download}
      fullWidth={props.fullWidth}
      sx={Object.assign(localSx, props.sx)}
      target={props.target}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialButton>
  );
}

export function PrimaryButton(props: ButtonProps) {
  return (
    <Button {...props}
      className={props.className}
      color="primary"
    />
  );
}

export function SecondaryButton(props: ButtonProps) {
  return (
    <Button {...props}
      className={props.className}
      color="secondary"
    />
  );
}

export function SecondaryTextButton(props: ButtonProps) {
  return (
    <Button {...props}
      className={props.className}
      color="secondary"
      sx={{ textTransform: 'uppercase' }}
    />
  );
}

export function SuccessButton(props: ButtonProps) {
  return (
    <Button {...props}
      className={props.className}
      color="success"
    />
  );
}

export function ErrorButton(props: ButtonProps) {
  return (
    <Button {...props}
      className={props.className}
      color="error"
    />
  );
}

export function GrayContainedButton(props: ButtonProps) {
  return (
    <Button {...props}
      className={`${props.className} ${styles.ButtonContainedGray}`}
    />
  );
}

export function GrayOutlinedButton(props: ButtonProps) {
  return (
    <Button {...props}
      className={`${props.className} ${styles.ButtonOutlinedGray}`}
    />
  );
}

export function GrayTextButton(props: ButtonProps) {
  return (
    <Button {...props}
      className={`${props.className} ${styles.ButtonTextGray}`}
    />
  );
}

export function UploadButton(props: ButtonProps) {
  return (
    <label>
      <Input accept="image/*" multiple type="file" />
      <Button {...props} className={props.className} />
    </label>
  );
}

export default Button;